<template>
  <ParentPortal :tabs="sidePanelComponents">
    <router-view v-if="nomination"
                 :nomination="nomination"
                 class="main-content"/>
  </ParentPortal>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { IfacAwardDetails, IfacNominationReferences } from '@ifac/ui';
import awardsMixin from '@/mixins/awards/awards.mixin';
import nominationsMixin from '@/mixins/awards/nominations.mixin';
import ParentPortal from '@/views/components/portals/ParentPortal.vue';
import { mapGetters } from 'vuex';
import References from '@/services/Api/Awards/References';

export default {
  mixins: [awardsMixin, nominationsMixin],
  name: 'NominationsEditPortal',
  components: {
    ParentPortal,
    IfacAwardDetails,
    IfacNominationReferences,
  },
  created() {
    this.mx_fetchNomination().then((response) => {
      this.nomination = response.data.data;
      // this.fetchReferences(this.nomination);
    });
  },
  data() {
    return {
      nomination: null,
      references: [],
    };
  },
  methods: {
      fetchReferences(nomination) {
        const params = {
          nomination_id: nomination.id,
          relations: ['affiliate'],
        };

        References.all(params).then((response) => {
          this.references = response.data.data;
        });
      },
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
    sidePanelComponents() {
      const tabs = [
        {
          icon: ['far', 'award'],
          headerText: 'Award',
          component: IfacAwardDetails,
          options: {
            award: this.nomination?.award,
            nomination: this.nomination,
            isLoading: false,
          },
        },
      ];

      // Reference Letters
      if (this.nomination?.can.viewReferences) {
        tabs.push({
          icon: ['far', 'envelope'],
          headerText: 'Reference letters',
          component: IfacNominationReferences,
          options: {
            nomination: this.nomination,
            // references: this.references,
            isLoading: false,
          },
        });
      }

      return tabs;
    },
  },
};
</script>
